import { AcaoPermitidaParaPlanoEscolhidoEnum } from 'business/http/dto/ConfirmOTPResponse'
import { storeUserDataMixin } from '@/business/user/mixins'
import { TIMELINE_LOADING_STEPS } from '../../components/TimelineLoading.vue'
import { loadUserInitialValidation, storeUserInitialValidation } from '../user/store'
import { isTestNumber } from '../../common/utils'

const saleMixin = {
  mixins: [storeUserDataMixin],
  methods: {
    validateInLastStep (msisdn) {
      // Msisdn com final par deve validar dados da venda na última etapa
      return Number(msisdn.slice(-1)) % 2 === 0
    },
    async fetchCardsService (msisdn) {
      try {
        if (!this.userCards || this.userCards.length === 0) {
          this.loadStep = TIMELINE_LOADING_STEPS.DADOS_CARTAO
          const cardsResponse = await this.$userService.fetchCards(msisdn)
          await this.storeUserCards(cardsResponse.cartoes)
        }
      } catch (e) {}
    },
    async initialValidation (cpf, msisdn) {
      const initialState = await this.loadUserInitialValidation()
      if (!initialState) {
        const { offerId } = this

        this.isLoading = true
        this.loadStep = TIMELINE_LOADING_STEPS.DADOS_PESSOAIS
        const response = await this.$userService.validateUserProcess(
          cpf,
          msisdn,
          offerId
        )

        this.loadStep = TIMELINE_LOADING_STEPS.PLANO
        await this.storeUserAndPlanSituation(response.action)
        if (response.action === AcaoPermitidaParaPlanoEscolhidoEnum.NENHUMA) {
          this.isProcessing = false
          this.isModalOpen = true
          return
        }
        if (response.action === AcaoPermitidaParaPlanoEscolhidoEnum.ADESAO) {
          await this.fetchCardsService(msisdn)
        }

        if (response.shouldValidateOtp) {
          this.$router.push({ name: 'page-sms-token' })
        } else {
          this.$router.push({ name: isTestNumber(msisdn) ? 'page-3-step-smartcheckout' : 'page-3-step' })
        }
        return response
      } else {
        this.$router.push({ name: isTestNumber(msisdn) ? 'page-3-step-smartcheckout' : 'page-3-step' })
        return { shouldValidateOtp: false }
      }
    },
    async loadUserInitialValidation () {
      return await loadUserInitialValidation()
    },
    async confirmUserInitialValidation () {
      await storeUserInitialValidation(true)
    }
  }
}

export { saleMixin }
